
export class IdiomaService  {

  private LOCAL_STORAGE_NAME: string = "IDIOMA_DATA";

  getIdiomaSeleccionado(): string | undefined {
    const data = localStorage.getItem(this.LOCAL_STORAGE_NAME);
    if (!data) {
      return "es";
    }
    return data;
  }

  updateIdioma(lang: string) {
    localStorage.setItem(this.LOCAL_STORAGE_NAME, lang);
  }

}

export default new IdiomaService();

